<template>
  <div>
    <b-modal v-if="!isEmpty(selected_media)" :active.sync="show_video">
      <figure v-if="selected_media.type == 'image'" class="image">
        <img :src="selected_media.link_source">
      </figure>
      <youtube v-if="selected_media.type == 'youtube'" :id="selected_media.youtubeId"
        :onPlaying="onPlaying" :onPaused="onPaused" :onBuffer="onBuffer" :onEnded="onEnded"
      ></youtube>
      <video-manager v-else-if="selected_media.type == 'video' && !isEmpty(playerOptions.sources)" :videos="[{
        file: {
          link: selected_media.link_source,
        },
        mime: selected_media.mime,
        type: selected_media.type
      }]" :onPlaying="onPlaying" :onPaused="onPaused" :onBuffer="onBuffer" :onEnded="onEnded"></video-manager>
      <button class="modal-close is-large" aria-label="close" @click.prevent="show_video = false"></button>
    </b-modal>

    <div class="vue-carousel" style="margin-bottom: 10px;">
      <carousel :perPage="1">
        <slide v-for="(m, key) in items" :key="key">
          <figure :style="figureStyles" v-if="!isEmpty(m) && m.type == 'image'" class="image" @click.prevent="selectMedia(m)" style="cursor: pointer;">
            <img :src="m.link_thumb" style="margin: 0; width: 100%; min-height: 100%;" />
          </figure>

          <figure :style="figureStyles" v-else-if="m.type == 'youtube'" class="image" @click.prevent="selectMedia(m)" style="cursor: pointer;">
            <div class="overlay">
              <div class="columns is-vcentered is-mobile" style="height: 100%;">
                <div class="column has-text-centered">
                  <button class="button is-large is-boxed-2 has-text-white" style="border: none; background
  : linear-gradient(90deg, #00F5A0, #00D9F5);">
                    <span class="icon"><i class="fas fa-caret-right fa-lg"></i></span>
                  </button>
                </div>
              </div>
            </div>
            <img :src="`https://img.youtube.com/vi/${m.youtubeId}/0.jpg`"/>
          </figure>

          <figure :style="figureStyles" v-else-if="m.type == 'video'" class="image" @click.prevent="selectMedia(m)" style="cursor: pointer;">
            <div class="overlay">
              <div class="columns is-vcentered is-mobile" style="height: 100%;">
                <div class="column has-text-centered">
                  <button class="button is-large is-boxed-2 has-text-white" style="border: none; background: linear-gradient(90deg, #00F5A0, #00D9F5);" >
                    <span class="icon">
                      <i class="fas fa-caret-right fa-lg"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <video-manager :videos="[{
              file: {
                link: m.link_source,
              },
              mime: m.mime,
              type: m.type
            }]"></video-manager>
          </figure>

          <p v-if="m.type === 'youtube'" class="help" style="margin-top: 10px;"><span class="has-text-danger font-w-600">*Catatan:</span> Progress video tidak terhitung jika pengguna mempercepat video dan berpindah halaman</p>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import VideoManager from '~/components/VideoManager';

export default {
  components: {
    VideoManager
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    selectImage: {
      type: Function,
      default: () => {}
    },
    with_desc: {
      type: Boolean,
      default: false
    },
    use_slot: {
      type: Boolean,
      default: false
    },
    onPlaying: {
      type: Function,
      default: () => {}
    },
    onPaused: {
      type: Function,
      default: () => {}
    },
    onBuffer: {
      type: Function,
      default: () => {}
    },
    onEnded: {
      type: Function,
      default: () => {}
    },
    figureStyles: {
      type: String,
      default: ''
    }
  },

  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    show_video: {
      get() {
        return !this.isEmpty(this.selected_media) ? true : false
      },
      set(val) {
        if (val) {
        } else {
          this.selected_media = null
        }
      }
    }
  },

  watch: {
    selected_media(video) {
      if (!this.isEmpty(video)) {
        this.playerOptions["sources"] = [{
          type: "video/mp4",
          src: video.link_source,
        }]
      } else {
        this.playerOptions["sources"] = []
      }
    }
  },

  data() {
    return {
      selected_media: null,
      playerOptions: {
        fluid: true,
        autoplay: true,
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster: "/assets/img/video-bg.png",
      }
    }
  },

  methods: {
    selectMedia(m) {
      this.selected_media = m
    },
    // listen event
    onPlayerPlay(player) {
      // this.onPlaying(player, player.duration())
    },
    onPlayerPause(player) {
      this.onPaused(player, player.duration())
    },
    onPlayerEnded(player) {
      this.onEnded(player, player.duration())
    },
    onPlayerLoadeddata(player) {
      // console.log('player Loadeddata!', player)
    },
    onPlayerWaiting(player) {
      this.onBuffer(player, player.duration())
    },
    onPlayerPlaying(player) {
      this.onPlaying(player, player.duration())
    },
    onPlayerTimeupdate(player) {
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    // player is ready
    playerReadied(player) {
    }
  }
}
</script>

<style scoped lang="scss">
.vue-carousel figure.image {
  width: 100%;
  height: 350px;
  overflow: hidden;
  margin: auto;

  img {
    margin: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.vue-carousel .image {
  img {
    transition: 0.3s;

    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>

